import type { ArtworkWrapper } from "@/types/artworksData";
import * as THREE from "three";

export const PSEUDO_MOM_TAG_LIGHT_COLORS = {
  Knowledge: 0x89cff0,
  Infotainment: 0xffa500,
  Creativity: 0xff00ff,
  Curation: 0xffff00,
} as const;

export const PSEUDO_MOM_BASE_LIGHT_COLOR = 0xffb64e;
export const PSEUDO_MOM_DEFAULT_LIGHT_COLOR = 0xffffff;
export const PSEUDO_MOM_TAG_LIGHT_HIDDEN_POSITION = new THREE.Vector3(0, -50, 0);

export type PseudoMoMReuseLegendItem = {
  label: string;
  color: number;
  colorHex: string;
};

const PSEUDO_MOM_TAG_COLOR_BY_NORMALIZED = new Map<string, number>(
  Object.entries(PSEUDO_MOM_TAG_LIGHT_COLORS).map(([tag, color]) => [tag.toLowerCase(), color])
);

export function resolvePseudoMoMTagLightColor(tags?: string | null): number | null {
  if (!tags) return null;

  const tagParts = tags
    .split(",")
    .map((tag) => tag.trim().toLowerCase())
    .filter(Boolean);

  for (const tag of tagParts) {
    const color = PSEUDO_MOM_TAG_COLOR_BY_NORMALIZED.get(tag);
    if (color !== undefined) return color;
  }

  return null;
}

export function resolvePseudoMoMArtworkLightColor(artwork?: { tags?: string | null } | null): number | null {
  if (!artwork) return null;

  return resolvePseudoMoMTagLightColor(artwork.tags) ?? PSEUDO_MOM_DEFAULT_LIGHT_COLOR;
}

export function resolvePseudoMoMWrapperLightColor(artworkWrapper?: ArtworkWrapper | null): number | null {
  const activeArtworkIndex = Number(artworkWrapper?.activeArtwork);
  if (!Number.isInteger(activeArtworkIndex)) return null;
  const activeArtwork = artworkWrapper?.artworks?.[activeArtworkIndex];

  return resolvePseudoMoMArtworkLightColor(activeArtwork);
}

export function pseudoMoMColorToCssHex(color: number): string {
  return `#${color.toString(16).padStart(6, "0")}`;
}

export function getPseudoMoMReuseLegendItems(): PseudoMoMReuseLegendItem[] {
  return [
    { label: "Understanding Europe", color: PSEUDO_MOM_TAG_LIGHT_COLORS.Knowledge },
    { label: "Experiencing Europe", color: PSEUDO_MOM_TAG_LIGHT_COLORS.Infotainment },
    { label: "Reimagining Europe", color: PSEUDO_MOM_TAG_LIGHT_COLORS.Creativity },
    { label: "Safeguarding Europe", color: PSEUDO_MOM_TAG_LIGHT_COLORS.Curation },
    { label: "Guest", color: PSEUDO_MOM_DEFAULT_LIGHT_COLOR },
  ].map((item) => ({
    ...item,
    colorHex: pseudoMoMColorToCssHex(item.color),
  }));
}
